import { useState, useEffect } from 'react';
import api from '@host/axios';
import { CRM_ON } from '../lib/hostModules';

// Bốn số đếm dưới đây đều của cụm CRM / fulfillment. Hệ TẮT CRM (Site Connect 12/10/2026: `modules.crm = false`
// ở config/tenant.js của host — không bán CRM) thì không gọi gì: trước đó hub Site Connect vẫn bắn ~92 lượt
// /crm/* mỗi endpoint trong 14 ngày (useBadgeRealtime gọi refreshBadgeCounts mỗi lần `badge:refresh`).
// Core + Work SaaS khai `crm: true` ⇒ giữ nguyên.

let cachedCounts = {};
let listeners = new Set();
let _intervalStarted = false; // singleton guard — tránh mỗi mount tạo 1 interval (trước đây
                              // 4 component dùng hook = 4 interval = 4× request trùng).

function notify() { listeners.forEach(fn => fn({ ...cachedCounts })); }

export function refreshBadgeCounts() {
  // Pause khi tab ẩn — KHÔNG poll nền (cắt phần lớn request ở background tab).
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
  if (!CRM_ON) return;
  Promise.all([
    api.get('/crm/my-deal-invites/count').then(r => { cachedCounts['crm-deals'] = r.data.data?.count || 0; }).catch(() => {}),
    api.get('/crm/quotation-pending-approvals').then(r => { cachedCounts['crm-quotations'] = (r.data.data || []).length || 0; }).catch(() => {}),
    api.get('/crm/payments', { params: { status: 'pending', limit: 1 } }).then(r => { cachedCounts['crm-payments'] = r.data.pagination?.total || 0; }).catch(() => {}),
    api.get('/fulfillment/orders/pending-count').then(r => {
      const d = r.data.data || {};
      cachedCounts['fulfillment-orders'] = d.count || 0; // backward-compat (tổng)
      cachedCounts['fulfillment-pending-acceptance'] = d.pending_acceptance || 0;
      cachedCounts['fulfillment-pending'] = d.pending || 0;
    }).catch(() => {}),
  ]).then(notify);
}

// Khởi động polling 1 LẦN cho cả app (singleton) — dù bao nhiêu component mount hook.
function startPollingOnce() {
  if (_intervalStarted || typeof window === 'undefined' || !CRM_ON) return;
  _intervalStarted = true;
  // 120s — badge approval CRM không cần realtime; mutate quan trọng tự trigger refresh riêng.
  setInterval(refreshBadgeCounts, 120000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshBadgeCounts();
  });
}

export default function useBadgeCounts() {
  const [counts, setCounts] = useState(cachedCounts);

  useEffect(() => {
    listeners.add(setCounts);
    // Initial load (chỉ khi chưa có cache — nhiều component mount không refetch lại).
    if (Object.keys(cachedCounts).length === 0) refreshBadgeCounts();
    startPollingOnce(); // singleton — KHÔNG tạo interval mới mỗi mount.
    return () => { listeners.delete(setCounts); };
  }, []);

  return counts;
}
